
export const handleDefaultDataProps = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dataProps: Record<string, any>,
  fieldName: string,
  defaultMask: boolean
) => {
  return {
    ...(defaultMask ? { "data-sl": "mask" } : {}),
    "data-bind-value": fieldName,
    "data-fb-input": fieldName,
    ...dataProps
  };
};
